"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = TD;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classnames = _interopRequireDefault(require("classnames"));

var _filterDOMProps = _interopRequireDefault(require("../../utils/filterDOMProps"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

/*************************************************************************
* ADOBE CONFIDENTIAL
* ___________________
*
* Copyright 2019 Adobe
* All Rights Reserved.
*
* NOTICE: All information contained herein is, and remains
* the property of Adobe and its suppliers, if any. The intellectual
* and technical concepts contained herein are proprietary to Adobe
* and its suppliers and are protected by all applicable intellectual
* property laws, including trade secret and copyright laws.
* Dissemination of this information or reproduction of this material
* is strictly forbidden unless prior written permission is obtained
* from Adobe.
**************************************************************************/

/**
 * A table cell
 */
function TD(_ref) {
  var className = _ref.className,
      children = _ref.children,
      divider = _ref.divider,
      otherProps = (0, _objectWithoutProperties2["default"])(_ref, ["className", "children", "divider"]);
  return _react["default"].createElement("td", (0, _extends2["default"])({
    className: (0, _classnames["default"])('spectrum-Table-cell', {
      'spectrum-Table-cell--divider': divider
    }, className)
  }, (0, _filterDOMProps["default"])(otherProps)), children);
}

TD.displayName = 'TD';
TD.propTypes = {
  /** Whether or not to display a vertical dividing line to the right of the cell. */
  isDivider: _propTypes["default"].bool
};